<template lang="html">
  <div class="investment-reg container">
    <div class="investment-reg__card">
      <Icon
        v-if="currentPage !== 'GreetingPage'"
        class="investment-reg__card-icon_back"
        icon="ui-arrow-left"
        @click="goBack()"
      />
      <Component
        :is="currentPage"
        @alt="changePage($event)"
        @next="changePage($event)"
      />
    </div>
  </div>
</template>

<script>
import GreetingPage from '@/views/Rating/Investments/Registration/components/GreetingPage';
import ProfilePage from '@/views/Rating/Investments/Registration/components/ProfilePage';
import NichePage from '@/views/Rating/Investments/Registration/components/NichePage';
import TelegramPage from '@/views/Rating/Investments/Registration/components/TelegramPage';
import TelegramHelp from '@/views/Rating/Investments/Registration/components/TelegramHelp';
import FinishPage from '@/views/Rating/Investments/Registration/components/FinishPage';
import { createNamespacedHelpers } from 'vuex';
import $store from '@/store';

const { mapState } = createNamespacedHelpers('ratingInvestmentsRegistration');

export default {
  components: {
    NichePage,
    ProfilePage,
    GreetingPage,
    TelegramPage,
    TelegramHelp,
    FinishPage
  },
  async beforeRouteEnter(to, from, next) {
    if (
      !$store.state.auth.meta.getUserData &&
      !$store.state.auth.meta.gettingUserInfo
    ) {
      await $store.dispatch('auth/getUserInfo');
    }
    const user = $store.state['auth'].data.user;

    if (!user.needRegisterMarathonInvestment && !user.isAdmin) {
      next('/rating/investments/user');
    } else {
      next();
    }
  },
  data: () => ({
    pages: [
      'GreetingPage',
      'ProfilePage',
      'TelegramPage',
      'TelegramHelp',
      'NichePage',
      'FinishPage'
    ],
    currentPage: 'GreetingPage',
    navigationStack: []
  }),
  computed: {
    ...mapState({
      user: state => state.data.localUser
    })
  },
  async mounted() {
    await this.getCurrentStream();
    await this.getUserInfo();
    await this.getUserProfile();

    document.documentElement.classList.add('scroll');
  },
  destroyed() {
    document.documentElement.classList.remove('scroll');
  },
  methods: {
    getUserInfo() {
      return this.$store.dispatch('ratingInvestmentsRegistration/getUserInfo');
    },
    getSettings() {
      this.$store.dispatch('ratingInvestmentsRegistration/getSettings');
    },
    getCurrentStream() {
      this.$store.dispatch('ratingInvestmentsRegistration/getCurrentStream');
    },
    getUserProfile() {
      this.$store.dispatch('ratingInvestmentsRegistration/getInitialProfile');
    },
    changePage(pageName) {
      this.navigationStack.push(this.currentPage);
      this.currentPage = pageName;
    },
    goBack() {
      if (this.currentPage === 'GreetingPage') {
        this.$router.go(-1);
      } else {
        this.currentPage = this.navigationStack.pop();
      }
    }
  }
};
</script>
